module.exports = __webpack_public_path__ + "media/img/kanban/kanban-1-370159a22aa761842325d96e129ac70f.jpg";